import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import P2 from '@base/P2/P2';
import Image from '@base/Image';
import { Spacings } from '@styles/index';

const FlagIcon = 'Flag-outline-new.svg';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  p {
    margin-left: ${Spacings.SPACING_2};
  }

  img {
    height: ${Spacings.SPACING_4B};
    width: ${Spacings.SPACING_4B};
  }
`;

const ReportButton = ({ onClick }) => (
  <Wrapper onClick={onClick}>
    <Image height={16} width={16} src={FlagIcon} alt="report icon" />
    <P2>Report</P2>
  </Wrapper>
);

export default ReportButton;

ReportButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
